module.exports = __webpack_public_path__ + "img/weapon_s_12.png";